import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRtlComponent } from './simple-icons-rtl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRtlComponent ],
    exports:      [ SimpleIconsRtlComponent ],
    bootstrap:    []
})
export class SimpleIconsRtlModule {}
